'use client';

import React, { useLayoutEffect } from 'react';

import useReviewsProductWidgetScript from '../../../vendor/reviews_io/hooks/useReviewsProductWidgetScript';

type InitFunc = (id: string, skus: string) => void;

interface Props {
    skus: string;
    className?: string;
}

const ReviewsProductsWidget = ({ skus, className }: Props) => {
    const [initProductReview] = useReviewsProductWidgetScript();

    useLayoutEffect(() => {
        (initProductReview as InitFunc)('#ReviewsProductWidget', skus);
    }, [initProductReview, skus]);

    return <div id="ReviewsProductWidget" className={className} />;
};

export default ReviewsProductsWidget;
